import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import ArticleList1 from '../components/pages/blog/ArticleList'
import SocialLinks from '../components/pages/blog/SocialLinks'
import LatestArticles1 from '../components/pages/blog/LatestArticles'
import TagsList from '../components/pages/blog/TagsList'
import Billboard from '../components/Billboard'
import Seo from '../components/seo'

export const pageQuery = graphql`
  query($tag: String!) {
     allMarkdownRemark(
        sort: {fields: frontmatter___createdAt, order: DESC}
        filter: {fields: {collection: {eq: "blog-posts"}}, frontmatter: {tags: {in: [$tag]}}}
      ) {
        edges {
          node {
            id
            frontmatter {
                title
                createdAt(formatString: "LL")
                slug 
                summary
                tags
                featuredImage
            }
             fields {
                featuredImage {
                  childImageSharp {
                    original {
                      height
                      width
                    }
                    gatsbyImageData (
                      width: 250
                      backgroundColor: "transparent"
                    )
                  }
                }
              }            
          }
        }
      }
  }
`

const Tag = ({ data, pageContext }) => {
  const tag = pageContext.tag
  const articles = data.allMarkdownRemark.edges

  return (
    <Layout>
      <Seo title={`${tag.toUpperCase()} Tag`} />

      <Billboard className="Billboard--blog" color="white">
        <div className="Billboard__top">
          <h1 className="Billboard__title">Expert aws cloud insights</h1>
          <div className="Billboard__lead">
            Articles tagged "{tag.toUpperCase()}"
          </div>

          <div className="Billboard__cta" />
        </div>
      </Billboard>

      <section className="section wave-billboard-above footer-bottom-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <ArticleList1 articles={articles} />
            </div>

            <div className="col-md-4">
              <div className="blogSidebar">
                <SocialLinks />
                <LatestArticles1 />
                <TagsList />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Tag
